import protobuf from "protobufjs";
import communication from "./communication.json";

const root = protobuf.Root.fromJSON(communication);
export default root;
